export default __webpack_public_path__ + "freeweekend-locales/pt-BR.55f17e38c7f1424f982cb7cd1f3a93ce.json";